<script setup>
import TheHeader from '@/Components/Website/layout/TheHeader.vue'
import HomeHeader from '@/Components/WebLayout/HomeHeader.vue'
import TheFooter from '@/Components/Website/layout/TheFooter.vue'
import { usePage } from '@inertiajs/vue3'
import { computed, watchEffect } from 'vue'
import { useLocale } from 'vuetify'

const page = usePage()
const { current } = useLocale()

const direction = computed(() => {
    return page.props.locale === 'ar' ? 'rtl' : 'ltr'
})

// Check if current page is home
const isHomePage = computed(() => {
    return page.component === 'Website/Home';
})

watchEffect(() => {
    if (page.props.locale) {
        current.value = page.props.locale
    }
})
</script>

<template>
    <v-app class="font-sans bg-surface-light dark:bg-slate-950 dark:text-gray-100" :class="direction">
        <!-- <TheHeader /> -->
        <HomeHeader />

        <v-main :class="isHomePage ? 'pt-0' : 'pt-20'">
            <slot />
        </v-main>

        <TheFooter />
    </v-app>
</template>

<style>
/* Global transitions */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
